const urlHashParams = (location) => {
  const hashParams = new URLSearchParams(location.hash.replace(/^#/, ''));
  return Object.fromEntries(hashParams);
};

export default urlHashParams;
